
(function() {
  var result = { translations: { "en": { "foundations-components": { "ActionsMenu": { "defaultAriaLabel": "Actions" }, "tag": { "remove": "Remove tag" }, "Select": { "noResults": "No results found", "searchPlaceholder": "Search...", "clearSelections": "Clear selections" }, "ErrorMessage": { "error": { "title": "All is not lost." }, "notFound": { "title": "All who wander are not lost." }, "badRequest": { "title": "There was a problem loading this page." }, "expired": { "title": "We're sorry." }, "sessionId": { "prefix": "Session Id: " } }, "ProgressSteps": { "completedStep": "Completed step", "incompleteStep": "Incomplete step" }, "Paginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "You are currently on ", "description": "Page " }, "firstPage": { "label": "First", "description": "First page" }, "previousPage": { "label": "Prev", "description": "Previous page" }, "nextPage": { "label": "Next", "description": "Next page" }, "lastPage": { "label": "Last", "description": "Last page" } }, "Datagrid": { "noData": { "Title": "No data available", "Description": "There is no data available to display." }, "noResults": { "Title": "No results found", "Description": "Try adjusting your search and filters to find what you're looking for.", "ClearActionLabel": "Clear search and filters" }, "toolbar": { "selectedRows": { "one": "{{count}} row selected", "other": "{{count}} rows selected", "clearSelection": "Clear selection", "selectAll": "Select all {{totalRows}} rows" }, "search": { "placeholder": "Search", "label": "Search", "clearSearch": "Clear search" } }, "pagination": { "visibleRows": "{{visibleRows}} of {{totalRows}} results", "itemsPerPage": "Items per page", "countPerPage": { "one": "{{count}} per page", "other": "{{count}} per page" } }, "SkeletonGrid": { "loading": "Loading" }, "DataGridColumnManagementPanel": { "description": "Choose which properties to display as columns. Then, move properties up or down, or drag and drop, to change the order they will be displayed.", "removeAllColumns": "Remove all columns", "update": "Update", "cancel": "Cancel", "edit": "Edit columns" } } }, "ui": { "UIAbstractPageSection": { "page": "Page Section" }, "UICarousel": { "current": "Showing item {{currentStepDisplayNumber}} out of {{totalSteps}}", "prev": "Previous", "next": "Next", "tip": "Use arrow keys to see other items" }, "UIColorSwatch": { "label": "Color picker {{value}}", "noColorLabel": "Color picker, no color selected." }, "UIButtonCollapser": { "dropdownLabel": "Actions" }, "UIErrorMessage": { "error": { "title": "All is not lost." }, "notFound": { "title": "All who wander are not lost." }, "badRequest": { "title": "There was a problem loading this page." }, "expired": { "title": "We're sorry." } }, "UIPanelNavigator": { "backButton": "Go to previous screen" }, "UILoadingSpinner": { "busyText": "Loading", "completedText": "Loaded" }, "UISideNav": { "navigationLandmark": "Secondary" }, "UISortTH": { "ascendingSort": "Ascending sort. Press to sort descending.", "descendingSort": "Descending sort. Press to sort ascending.", "pressToSort": "Press to sort." }, "autosizedTextInput": { "charactersRemaining": "{{value}} characters remaining" }, "time": { "today": "Today at {{time}}", "yesterday": "Yesterday at {{time}}", "datetime": "{{date}} at {{time}}" }, "progress": { "percentComplete": "{{percent}} complete" }, "datePicker": { "dateSelected": "{{date}} is selected.", "noDateSelected": "No date selected.", "dateBelowMin": "You must choose a newer date", "dateAboveMax": "You must choose an older date", "invalidDate": "Invalid date", "today": "Today", "clear": "Clear", "placeholder": { "month": "MM", "day": "DD", "year": "YYYY" }, "nextMonth": "Next month", "prevMonth": "Previous month" }, "dateRange": { "startDate": "Start date", "endDate": "End date", "endDateBeforeStartDate": "The end date must come after the start date.", "startDateAfterEndDate": "The start date must come before the end date.", "to": "to" }, "timePicker": { "placeholder": { "hour": "HH", "minute": "MM" } }, "SelectResultList": { "andMore": "\u2026and {{count}} more.", "loadMore": "Load more" } }, "salesUI": { "UIAvatarHoverlay": { "text": "Change photo" }, "UIChangeArrow": { "decrease": "Decrease of ", "increase": "Increase of " }, "UICopyInput": { "label": "Copy", "title": "Copy to clipboard", "tooltipCopied": "Copied" }, "UIConfirm": { "defaultConfirm": "Yes", "defaultReject": "No" }, "UICloseButton": { "label": "Close" }, "UIDateRangePicker": { "rangeType": { "ALL": "All time", "THIS_DAY": "Today", "LAST_DAY": "Yesterday", "THIS_WEEK": "This week", "LAST_WEEK": "Last week", "THIS_MONTH": "This month", "LAST_MONTH": "Last month", "LAST_THIRTY_DAYS": "Last 30 days", "LAST_THREE_MONTHS": "Last 3 months", "THIS_QUARTER": "This quarter", "LAST_QUARTER": "Last quarter", "THIS_YEAR": "This year", "LAST_YEAR": "Last year", "CUSTOM": "Custom time period" } }, "UIDropdownSelect": { "placeholder": "No value selected" }, "UIEditableControls": { "cancel": "Cancel", "save": "Save" }, "UIExpandableText": { "collapseButtonText": "See less", "expandButtonText": "See more" }, "UIFileInput": { "defaultChangeLabel": "Change file", "defaultSelectLabel": "Choose file" }, "UIIconRating": { "ariaValueText": "{{value}} of {{maxValue}}" }, "UILink": { "externalTitle": "Link opens in a new window" }, "UILoading": { "title": "Loading\u2026" }, "UILockBadge": { "title": "This feature is locked" }, "UIPaginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "You are currently on ", "description": "Page " }, "firstPage": { "label": "First", "description": "First page" }, "previousPage": { "label": "Prev", "description": "Previous page" }, "nextPage": { "label": "Next", "description": "Next page" }, "lastPage": { "label": "Last", "description": "Last page" } }, "UIPreviousButton": { "label": "Previous" }, "UINextButton": { "label": "Next" }, "UINumberRating": { "lowRangeLabel": "Strongly disagree", "highRangeLabel": "Strongly agree" }, "UISearchableSelectInput": { "placeholder": "Search" }, "UISearchInput": { "placeholder": "Search", "minimumSearchMessage": { "one": "Type 1 more character", "other": "Type {{count}} more characters" }, "clearButton": "Clear input" }, "UISelect": { "allOptionsSelected": "All options are selected", "createOption": "Create option \u201C{{label}}\u201D", "plusMore": "+ {{count}} more", "andMore": "\u2026and {{count}} more.", "loadMore": "Load more", "noResults": "No results found", "placeholder": "Search", "typeToSearch": "Type to search" }, "UITable": { "selectableTableRow": { "toggleSelection": "Toggle selection of the row" } }, "UITabs": { "moreDropdownLabel": "More" }, "UITeaseNotification": { "optionsButtonTooltipText": "Show options" }, "UITimePicker": { "placeholder": "Select a time" }, "UIToggle": { "checkedLabel": "ON", "uncheckedLabel": "OFF" }, "UITypeahead": { "noMatchesFound": "No matches found", "noOptions": "None" }, "UIWizard": { "back": "Back", "cancel": "Cancel", "done": "Done", "next": "Next", "stepCount": "Step {{stepNumber}} of {{stepCount}}" }, "XSSTooltip": { "explanation": "This link has been disabled for your security." } } } } };
  result.translationsLoaded = {
  "foundations-components": {
    "en": "static-1.4168"
  }
};
  result.translationsAvailable = {
  "foundations-components": {
    "af": "static-1.4168",
    "ar-eg": "static-1.4168",
    "bg": "static-1.4168",
    "bn": "static-1.4168",
    "ca-es": "static-1.4168",
    "cs": "static-1.4168",
    "da": "static-1.4168",
    "de": "static-1.4168",
    "el": "static-1.4168",
    "en-gb": "static-1.4168",
    "en": "static-1.4168",
    "es-mx": "static-1.4168",
    "es": "static-1.4168",
    "et": "static-1.4168",
    "fi": "static-1.4168",
    "fr-ca": "static-1.4168",
    "fr": "static-1.4168",
    "he-il": "static-1.4168",
    "hi": "static-1.4168",
    "hr": "static-1.4168",
    "hu": "static-1.4168",
    "id": "static-1.4168",
    "it": "static-1.4168",
    "ja": "static-1.4168",
    "ko": "static-1.4168",
    "lt": "static-1.4168",
    "ms": "static-1.4168",
    "nl": "static-1.4168",
    "no": "static-1.4168",
    "pl": "static-1.4168",
    "pt-br": "static-1.4168",
    "pt-pt": "static-1.4168",
    "ro": "static-1.4168",
    "ru": "static-1.4168",
    "sk": "static-1.4168",
    "sl": "static-1.4168",
    "sv": "static-1.4168",
    "th": "static-1.4168",
    "tl": "static-1.4168",
    "tr": "static-1.4168",
    "uk": "static-1.4168",
    "vi": "static-1.4168",
    "zh-cn": "static-1.4168",
    "zh-hk": "static-1.4168",
    "zh-tw": "static-1.4168"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:foundations-components:en', {version: 'static-1.4168'}); }
})();



(function() {
  var result = { translations: { "en": { "placeholder": "placeholder" } } };
  result.translationsLoaded = {
  "UIComponents": {
    "en": "static-3.5978"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.5978",
    "ar-eg": "static-3.5978",
    "bg": "static-3.5978",
    "bn": "static-3.5978",
    "ca-es": "static-3.5978",
    "cs": "static-3.5978",
    "da": "static-3.5978",
    "de": "static-3.5978",
    "el": "static-3.5978",
    "en-gb": "static-3.5978",
    "en": "static-3.5978",
    "es-mx": "static-3.5978",
    "es": "static-3.5978",
    "et": "static-3.5978",
    "fi": "static-3.5978",
    "fr-ca": "static-3.5978",
    "fr": "static-3.5978",
    "he-il": "static-3.5978",
    "hi": "static-3.5978",
    "hr": "static-3.5978",
    "hu": "static-3.5978",
    "id": "static-3.5978",
    "it": "static-3.5978",
    "ja": "static-3.5978",
    "ko": "static-3.5978",
    "lt": "static-3.5978",
    "ms": "static-3.5978",
    "nl": "static-3.5978",
    "no": "static-3.5978",
    "pl": "static-3.5978",
    "pt-br": "static-3.5978",
    "pt-pt": "static-3.5978",
    "ro": "static-3.5978",
    "ru": "static-3.5978",
    "sk": "static-3.5978",
    "sl": "static-3.5978",
    "sv": "static-3.5978",
    "th": "static-3.5978",
    "tl": "static-3.5978",
    "tr": "static-3.5978",
    "uk": "static-3.5978",
    "vi": "static-3.5978",
    "zh-cn": "static-3.5978",
    "zh-hk": "static-3.5978",
    "zh-tw": "static-3.5978"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:en', {version: 'static-3.5978'}); }
})();



(function() {
  var result = { translations: { "en": { "feedback-shared": { "alerts": { "limits": { "CSAT": { "total": { "body": "You can only create {{ limitNum }} customer satisfaction surveys (CSAT). This includes active, draft, and inactive surveys. To create a new survey, you'll need to delete an existing survey or contact support for help.", "title": "You\u2019ve hit the survey limit." } }, "CUSTOM": { "total": { "body": "You can only create {{ limitNum }} custom surveys (CUSTOM). This includes active, draft, and inactive surveys. To create a new survey, you'll need to delete an existing survey or contact support for help.", "title": "You\u2019ve hit the survey limit." } }, "NPS": { "total": { "body": "You can only create {{ limitNum }} customer loyalty surveys (NPS) at any one time. This includes active, draft, and inactive surveys. To create a new survey, you'll need to delete an existing survey or contact support for help.", "title": "You\u2019ve hit the survey limit." } }, "CSAT_NPS": { "total": { "body": "You can only create {{ npsLimitNum }} customer loyalty surveys (NPS) and {{ csatLimitNum }} customer satisfaction surveys (CSAT). This includes active, draft, and inactive surveys. To create a new survey, you'll need to delete an existing survey or contact support for help.", "title": "You\u2019ve hit the survey limit." } }, "CSAT_CUSTOM_NPS": { "total": { "body": "You can only create {{ npsLimitNum }} customer loyalty surveys (NPS) and {{ csatLimitNum }} customer satisfaction surveys (CSAT). This includes active, draft, and inactive surveys. To create a new survey, you'll need to delete an existing survey or contact support for help.", "title": "You\u2019ve hit the survey limit." } } } }, "notifications": { "GENERIC_PROBLEM": "Sorry. There was a problem. Please refresh the page to try again." }, "preview": { "from": "<strong>From:</strong> {{ fromName }} ({{ fromEmail }})", "subject": "<strong>Subject:</strong> ", "tooltips": { "brandName_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, "To change the link in this footer, go to ", createElement( options, "Link", { href: props.url, external: "true" }, " settings" ) ); } }, "CES": { "introduction": "You recently asked us for help with an issue '<span class=\"static-tag-decorator\">Ticket: ID</span> <span class=\"static-tag-decorator\">Ticket: Title</span>'." }, "CUSTOM": { "buttons": { "submit": "Submit" }, "questions": { "starRatingQuestion": "How happy were you with the overall buying experience?", "textInputQuestionOne": "Did you find what you were looking for?", "textInputQuestionTwo": "What other products would you like us to stock?", "textInputQuestionThree": "How can we improve our shopping experience?", "radioQuestion": "Please select one of the following options", "checkboxQuestion": "Please select from the following options: ( check all that apply )", "dropdownQuestion": "Please select your preferred option", "multiLineQuesiton": "Could you tell us more about your experience", "singleLineQuesiton": "Please share your thoughts" } } }, "ratings": { "notLikely": "Not likely", "veryLikely": "Very likely", "positive": "Positive", "neutral": "Neutral", "negative": "Negative" }, "token": { "chat": "Chat: {{ token }}", "contact": "Contact: {{ token }}", "ticket": "Ticket: {{ token }}", "deal": "Deal: {{ token }}" }, "tokens": { "deal": { "id": "ID" }, "ticket": { "id": "ID", "subject": "Subject" } }, "modals": { "sharableLink": { "description": { "isDraft": "When you are ready to publish your survey, we'll provide you with a link to start sharing it with contacts.", "isPublished": "Start sharing your survey with contacts. Your survey has been securely published and ready to use at the web address below." }, "heading": "Copy a link to your survey", "previewLink": "View survey" }, "unpublish": { "confirmButtonLabel": "Yes, unpublish survey", "descriptionEmail": "Surveys will no longer be sent by email to contacts, and you won't receive any responses. You can still see all responses that have been submitted already.", "descriptionWeb": "Surveys will no longer be visible to visitors, and you won't receive any responses. You can still see all responses that have been submitted already.", "customEmailDurationReminder": "Surveys will no longer be sent by email to contacts from now. You may receive responses for the next 14 days. This is usually from contacts who have received your email but not yet filled out the survey. You can still see all responses that have been submitted already.", "heading": "Unpublish this survey?", "rejectButtonLabel": "Cancel", "CHAT": { "title": "This survey will be turned off for the following chatflows:", "description": "Visitors will no longer be asked for feedback at the end of the chat conversation. You can still see responses that have been submitted already." }, "CES": { "ALL_PIPELINES": "All pipelines", "description": "Support surveys will be turned off for the following ticket pipelines:" }, "warning": { "unsavedChanges": "Also, any unpublished changes for this survey will be lost. Are you sure you want to unpublish it?", "noChanges": "Are you sure you want to unpublish it?" } } } } } } };
  result.translationsLoaded = {
  "feedback-shared-ui": {
    "en": "static-1.43781"
  }
};
  result.translationsAvailable = {
  "feedback-shared-ui": {
    "af": "static-1.43781",
    "ar-eg": "static-1.43781",
    "bg": "static-1.43781",
    "bn": "static-1.43781",
    "ca-es": "static-1.43781",
    "cs": "static-1.43781",
    "da": "static-1.43781",
    "de": "static-1.43781",
    "el": "static-1.43781",
    "en-gb": "static-1.43781",
    "en": "static-1.43781",
    "es-mx": "static-1.43781",
    "es": "static-1.43781",
    "et": "static-1.43781",
    "fi": "static-1.43781",
    "fr-ca": "static-1.43781",
    "fr": "static-1.43781",
    "he-il": "static-1.43781",
    "hi": "static-1.43781",
    "hr": "static-1.43781",
    "hu": "static-1.43781",
    "id": "static-1.43781",
    "it": "static-1.43781",
    "ja": "static-1.43781",
    "ko": "static-1.43781",
    "lt": "static-1.43781",
    "ms": "static-1.43781",
    "nl": "static-1.43781",
    "no": "static-1.43781",
    "pl": "static-1.43781",
    "pt-br": "static-1.43781",
    "pt-pt": "static-1.43781",
    "ro": "static-1.43781",
    "ru": "static-1.43781",
    "sk": "static-1.43781",
    "sl": "static-1.43781",
    "sv": "static-1.43781",
    "th": "static-1.43781",
    "tl": "static-1.43781",
    "tr": "static-1.43781",
    "uk": "static-1.43781",
    "vi": "static-1.43781",
    "zh-cn": "static-1.43781",
    "zh-hk": "static-1.43781",
    "zh-tw": "static-1.43781"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:feedback-shared-ui:en', {version: 'static-1.43781'}); }
})();



(function() {
  var result = { translations: { "en": { "testSurvey": "Test survey", "testHeader": "This is a test survey.", "testBody": "This submission won't be recorded.", "app": { "htmlTitle": "Feedback Web UI" }, "pages": { "error": { "close": "Close", "heading": "There was a problem loading the survey. Please try again later." }, "navigation": { "close": "close frame" } } } } };
  result.translationsLoaded = {
  "feedback-web-renderer-ui": {
    "en": "static-1.25083"
  }
};
  result.translationsAvailable = {
  "feedback-web-renderer-ui": {
    "af": "static-1.25083",
    "ar-eg": "static-1.25083",
    "bg": "static-1.25083",
    "bn": "static-1.25083",
    "ca-es": "static-1.25083",
    "cs": "static-1.25083",
    "da": "static-1.25083",
    "de": "static-1.25083",
    "el": "static-1.25083",
    "en-gb": "static-1.25083",
    "en": "static-1.25083",
    "es-mx": "static-1.25083",
    "es": "static-1.25083",
    "et": "static-1.25083",
    "fi": "static-1.25083",
    "fr-ca": "static-1.25083",
    "fr": "static-1.25083",
    "he-il": "static-1.25083",
    "hi": "static-1.25083",
    "hr": "static-1.25083",
    "hu": "static-1.25083",
    "id": "static-1.25083",
    "it": "static-1.25083",
    "ja": "static-1.25083",
    "ko": "static-1.25083",
    "lt": "static-1.25083",
    "ms": "static-1.25083",
    "nl": "static-1.25083",
    "no": "static-1.25083",
    "pl": "static-1.25083",
    "pt-br": "static-1.25083",
    "pt-pt": "static-1.25083",
    "ro": "static-1.25083",
    "ru": "static-1.25083",
    "sk": "static-1.25083",
    "sl": "static-1.25083",
    "sv": "static-1.25083",
    "th": "static-1.25083",
    "tl": "static-1.25083",
    "tr": "static-1.25083",
    "uk": "static-1.25083",
    "vi": "static-1.25083",
    "zh-cn": "static-1.25083",
    "zh-hk": "static-1.25083",
    "zh-tw": "static-1.25083"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:feedback-web-renderer-ui:en', {version: 'static-1.25083'}); }
})();


